import { AppDispatch } from '../../../../app/store';
import { TpDataContext } from '../../../../data/interfaces';
import { FORM_DATATYPES, TpAutoFormDef, promptAutoForm } from '../../../../components/auto-form-modal/AutoForm';
import { updateElementLayoutHints, removeElement, moveElement } from '../../data/dashboardsSlice';
import { TpDashboardContext, TpDashboardElement } from '../interfaces';
import { TpElementLayoutHints } from '../layout-hints';
import { elemTypeMap } from './elementTypes';
import { getUserError } from '../../../../components/miscUtils';

export function performRemoveElement(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  id: string,
  dispatch: AppDispatch,
) {
  dispatch(removeElement({ dashboardDefId: dashboardContext.dashboardDefId, id }));
}

export function performMoveElement(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  id: string,
  direction: number,
  dispatch: AppDispatch,
) {
  dispatch(moveElement({ dashboardDefId: dashboardContext.dashboardDefId, id, direction }));
}

export function promptElementLayoutHints(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  element: TpDashboardElement,
  dispatch: AppDispatch,
) {
  const elementId: string = element.id;
  const currentLayoutHints: TpElementLayoutHints = element.elemLayoutHints || {
    sizeXRelative: 1,
    sizeXAbsolute: 0,
    sizeYRelative: 1,
    sizeYAbsolute: 0,
  };
  const form: TpAutoFormDef = {
    title: 'Element positioning hints',
    fields: [
      {
        id: 'sizeXRelative',
        name: 'Relative X size',
        dataType: FORM_DATATYPES.NUMBER,
        startContent: currentLayoutHints.sizeXRelative,
      },
      {
        id: 'sizeXAbsolute',
        name: 'Absolute X size',
        dataType: FORM_DATATYPES.NUMBER,
        startContent: currentLayoutHints.sizeXAbsolute,
      },
      {
        id: 'sizeYRelative',
        name: 'Relative Y size',
        dataType: FORM_DATATYPES.NUMBER,
        startContent: currentLayoutHints.sizeYRelative,
      },
      {
        id: 'sizeYAbsolute',
        name: 'Absolute Y size',
        dataType: FORM_DATATYPES.NUMBER,
        startContent: currentLayoutHints.sizeYAbsolute,
      },
    ],
  };

  promptAutoForm(form).then(
    (dataForm: any) => {
      const newLayoutHints = {
        ...currentLayoutHints,
        sizeXAbsolute: dataForm.sizeXAbsolute,
        sizeXRelative: dataForm.sizeXRelative,
        sizeYAbsolute: dataForm.sizeYAbsolute,
        sizeYRelative: dataForm.sizeYRelative,
      };
      dispatch(
        updateElementLayoutHints({ dashboardDefId: dashboardContext.dashboardDefId, id: elementId, newLayoutHints }),
      );
    },
    () => {},
  );
}

export function promptAddElement(
  dataContext: TpDataContext,
  dashboardContext: TpDashboardContext,
  parentElemTypeId: string,
  parentId: string,
  dispatch: AppDispatch,
) {
  const parentElemType = elemTypeMap[parentElemTypeId];
  if (!parentElemType) throw getUserError(`Invalid element type: ${parentElemTypeId}`);
  const form: TpAutoFormDef = {
    title: 'Add element',
    fields: [
      {
        id: 'type',
        name: 'Element type',
        dataType: FORM_DATATYPES.MULTIPLECHOICE,
        startContent: null,
        choices: parentElemType.compatibleChildren.map((childTypeId) => ({
          id: childTypeId,
          content: elemTypeMap[childTypeId].name,
        })),
      },
    ],
  };

  promptAutoForm(form).then(
    (formData: any) => {
      elemTypeMap[formData.type].promptAdd(dataContext, dashboardContext, parentId, dispatch);
    },
    () => {},
  );
}
